export default {
  // modules: {
  // }
  state: {
    filterMap: {},
    activePageMap: {},
    choiceCache: {}
  },
  getters: {
    getFilterByName: (state, getters) => (name) => {
      // console.log('getFilterByName', name)
      if (name in state.filterMap) { return state.filterMap[name] }
    },
    getActivePageByName: (state, getters) => (name) => {
      // console.log('getActivePageByName', name)
      if (name in state.activePageMap) return state.activePageMap[name]
      else return 1
    },
    getCachedChoice: (state, getters) => (name) => {
      // console.log('getCachedChoice', name)
      if (name in state.choiceCache) return state.choiceCache[name]
    }
  },
  mutations: {
    setFilter (state, payload) {
      // console.log('store.setFilter', payload)
      state.filterMap[payload.name] = payload.value
    },
    setActivePage (state, payload) {
      // console.log('store.setActivePage', payload)
      state.activePageMap[payload.name] = payload.value
    },
    setCachedChoice (state, payload) {
      // console.log('store.setCachedChoice', payload)
      state.choiceCache[payload.name] = payload.value
    }
  }
  // strict: true
}



// WEBPACK FOOTER //
// ./src/vuex/store.js